module.exports = __webpack_public_path__ + "fonts/Poppins-Thin.852bafc.woff2";